/* eslint-disable max-len */
import React from 'react';

interface ISuspendProps {
    width?: number | string;
    height?: number | string;
}

const Suspend: React.FC<ISuspendProps> = ({width = 12, height = 12}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.85547 10.5C6.85547 11.3284 7.52704 12 8.35547 12H9.64118C10.4696 12 11.1412 11.3284 11.1412 10.5V1.5C11.1412 0.671573 10.4696 0 9.64118 0H8.35547C7.52704 0 6.85547 0.671573 6.85547 1.5V10.5Z"
                fill="currentColor"
            />
            <path
                d="M0.855469 10.5C0.855469 11.3284 1.52704 12 2.35547 12H3.64118C4.46961 12 5.14118 11.3284 5.14118 10.5V1.5C5.14118 0.671573 4.46961 0 3.64118 0H2.35547C1.52704 0 0.855469 0.671573 0.855469 1.5V10.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Suspend;